import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authenticationReducer from "../features/authentication/authenticationSlice";
import accessUserProjectSliceReducer from "../features/userProjectAccess/accessUserProjectSlice";
import projectReducer from "../features/projects/projectSlice";
import taskReportsReducer from "../features/taskReports/taskReportsSlice";
import { injectStore } from "../features/axiosInstance/axiosInstance";
import clockifyTimeEntriesReducer from "../features/clockifyTimeEntries/clockifyTimeEntriesSlice";
import alertsSlice from "../features/alerts/alertsSlice";
import syncJobsReducer from "../features/syncJobs/syncJobsSlice";
import milestoneNotesReducer from "../features/milestoneNotes/milestoneNotesSlice";
import milestoneManagementReducer from "../features/milestoneManagement/milestoneManagementSlice";

export const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
    userProjectAccess: accessUserProjectSliceReducer,
    projects: projectReducer,
    taskReports: taskReportsReducer,
    clockifyTimeEntries: clockifyTimeEntriesReducer,
    alerts: alertsSlice,
    syncJobs: syncJobsReducer,
    milestoneNotes: milestoneNotesReducer,
    milestoneManagement: milestoneManagementReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

injectStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
